function updateBackgroundImage(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  const backgroundEl = document.querySelector('.testimonials-carousel__background-image');
  
  if (activeSlide && backgroundEl) {
    const img = activeSlide.querySelector('.testimonial-card__image img');
    if (img && img.src) {
      backgroundEl.style.backgroundImage = `url(${img.src})`;
    }
  }
}

let swiper = new Swiper(".testimonials-carousel__slider-wrapper", {
  slidesPerView: 1.1,
  spaceBetween: 16,
  centeredSlides: false,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 1.15,
      spaceBetween: 24,
    },
    990: {
      slidesPerView: 1,
      spaceBetween: 24,
    },
    1200: {
      slidesPerView: 1.25,
      spaceBetween: 40,
    },
  },
  on: {
    init: function() {
      updateBackgroundImage(this);
    },
    slideChange: function() {
      updateBackgroundImage(this);
    },
  },
});
